import React from "react";
import { Field } from "redux-form";
import { FormPhoneField } from "../../components/fields";
import ProgressButton from "../../components/ProgressButton";
import CardLayout from "../../layouts/CardLayout";
import { submitFormHandler } from "./actions";
import styles from "./style.module.css";

export default React.memo(({ handleSubmit, submitting, error, ...props }) =>
  <form className={styles.container} onSubmit={handleSubmit(submitFormHandler)}>
    <CardLayout footer={
      <ProgressButton variant='contained'
                      type='submit'
                      isFetching={submitting}
                      disabled={submitting}
                      color="primary"
                      className={styles.button}
      >
        Next
      </ProgressButton>
    }>
      <h3 className={styles.title}>
        Please enter your phone number
      </h3>
      <div className={styles.container}>
        <Field name="phone"
               component={FormPhoneField}
               fullWidth
               label="Phone number"
               disabled={submitting}
        />
        <span className={styles.text}>
              By clicking Next you agree to receive SMS. Mobile data transfer or SMS rates may be applied.
            </span>
      </div>
      <div className={styles.errorContainer}>
              <span className={styles.error}>
                {error}
              </span>
      </div>
    </CardLayout>
  </form>,
);
